import {IBanners} from '@api/leaderboard/banner/getLeaderboardBanners'
import React, {useCallback, useState} from 'react'
import Text from '@component/Text/Text'
import WizButton from '@component/buttons/WizButton'
import Link from 'next/link'
import useWindowSize from '@hook/useWindowSize'
import WizImage from '@component/images/WizImage'
import {createLog} from '@util/logs'
import IconNext from '@svg/common/ic_btn_next.svg'

interface IProps {
    className?: string
    data?: IBanners
}

const LeaderboardBannerItem: React.FC<IProps> = ({className, data}) => {
    const [isFocus, setIsFocus] = useState(false)
    const {isSm} = useWindowSize()
    const onClickMoreInfo = useCallback(() => {
        createLog('event', 'leaderBoard_banner_more_info_click', {banner_id: data?.id, title: data?.content?.title})
    }, [data])
    return (
        <div
            data-cy={'leaderboard_banner'}
            style={{backgroundColor: data?.background}}
            className={`w-full relative overflow-hidden h-[320px] sm:h-[270px]
             mx-auto`}>
            <div className={'layout-desktop overflow-hidden relative'}>
                <Link href={(data?.button?.link as string) || ''} onClick={onClickMoreInfo}>
                    <div
                        dir={'rtl'}
                        className={`absolute right-0 top-0 sm:right-auto sm:left-[50%] sm:translate-x-[-50%] sm:w-full`}>
                        <WizImage
                            src={data?.banner_image_pc}
                            isFetchPriority={true}
                            width={1920}
                            height={320}
                            containerClassName={'sm:hidden max-w-[100%]'}
                            imageClassName={'!w-full'}
                            loadingType={'eager'}
                        />
                        <WizImage
                            src={data?.banner_image_mo}
                            width={1920}
                            height={270}
                            containerClassName={'hidden sm:block max-w-[100%] w-full'}
                            imageClassName={'w-full'}
                            loadingType={'eager'}
                            isFetchPriority={true}
                        />
                    </div>
                    <div className={`flex-1 flex flex-col px-[20px] relative z-[10] pt-[75px] sm:pt-[73px]`}>
                        <div className={'flex-1 flex flex-col justify-center'}>
                            {data?.sub_title?.image_url ? (
                                <div className={'h-[36px] sm:h-[21px] flex flex-col justify-center'}>
                                    <div className={'h-[26px] sm:h-[21px] w-full'}>
                                        <WizImage
                                            src={data?.sub_title?.image_url}
                                            width={1920}
                                            containerClassName={'h-full'}
                                            imageClassName={'!w-auto'}
                                            height={isSm ? 21 : 26}
                                        />
                                    </div>
                                </div>
                            ) : data?.sub_title?.text ? (
                                <Text
                                    inlineStyle={{color: data?.sub_title?.color || '#FFFFFF'}}
                                    className={`text-h2 ${
                                        data?.content?.title &&
                                        data?.content?.title?.length >= 26 &&
                                        'md:text-[2.3vw] md:leading-[3.5vw]'
                                    } sm:text-ti2`}>
                                    {data?.sub_title?.text}
                                </Text>
                            ) : (
                                <></>
                            )}
                            {data?.content?.image_pc || data?.content?.image_mo ? (
                                <>
                                    <div className={'h-[154px] sm:h-[120px] w-full'}>
                                        <WizImage
                                            src={isSm ? data?.content?.image_mo : data?.content?.image_pc}
                                            width={1920}
                                            alt={`${data?.content?.title} ${data?.content?.desc}`}
                                            containerClassName={
                                                'max-h-[154px] max-w-[480px] sm:max-h-[120px] sm:max-w-[320px]'
                                            }
                                            height={isSm ? 120 : 154}
                                        />
                                    </div>
                                </>
                            ) : (
                                <Text
                                    inlineStyle={{color: data?.content?.title_color || '#FFFFFF'}}
                                    className={`antialiased font-sans text-white text-h1 break-all text-[40px] ${
                                        data?.content?.title &&
                                        data?.content?.title?.length >= 26 &&
                                        'md:text-[3.9vw] md:leading-[5.25vw]'
                                    } sm:text-h3 font-bold`}>
                                    {data?.content?.title}
                                </Text>
                            )}
                            {data?.content?.desc && (
                                <Text
                                    inlineStyle={{color: data?.content?.desc_color || '#FFFFFF'}}
                                    className={`text-body1 mt-[10px] sm:text-body3 sm:mt-[5px] break-all`}>
                                    {data?.content?.desc}
                                </Text>
                            )}
                            <div className={'flex items-center'}>
                                {data?.button?.view === 'view' && (
                                    <>
                                        <WizButton
                                            inlineStyle={{
                                                borderColor: data?.button?.border_color,
                                                backgroundColor: isFocus
                                                    ? data?.button?.hover_background_color || 'transparent'
                                                    : data?.button?.background_color || 'transparent',
                                            }}
                                            inlineTextStyle={{color: data?.button?.text_color}}
                                            text={data?.button?.text}
                                            onMouseEnter={() => setIsFocus(true)}
                                            onMouseLeave={() => setIsFocus(false)}
                                            size={'medium'}
                                            className={`${
                                                data?.content.image_pc ? 'mt-0' : 'mt-[30px] sm:mt-[20px]'
                                            } bg-transparent border hover:bg-transparent py-[12px] px-[20px] sm:hidden`}
                                            textClassName={'text-btn'}
                                        />

                                        <div className={'hidden sm:flex items-center sm:mt-[20px] cursor-pointer'}>
                                            <Text
                                                inlineStyle={{color: data?.button?.text_color}}
                                                className={'text-body2'}>
                                                {data?.button?.text}
                                            </Text>
                                            <IconNext style={{fill: data?.button?.text_color}} className={`w-[12px]`} />
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
        </div>
    )
}

export default LeaderboardBannerItem
